<div class="bg-white p-2" *ngIf="!report || report.anno">
  <div class="" *ngIf="!Entity && !report">
    <button *ngIf="!envirovment.ClientiAddOn['hideApprovaPresenze']"  class="btn btn-kindera " (click)="Approve()"><i class="fas fa-check pr-1"></i>Approva</button>
    <button class="btn btn-kindera"  (click)="Stampa()"><i class="fas fa-print pr-1"></i>Stampa</button>
    <button class="btn btn-kindera ml-auto"  (click)="Click()"><i class="fas fa-plus pr-1"></i>Inserisci</button>
  </div>
  <div class="form-row col-lg-12 bg-white p-2">
    <div class="col-lg-2" *ngIf="classiList.length > 0 && showClasse" >
      <span>
        <label>Classe</label>
        <ng-multiselect-dropdown [settings]="dropSettingOnlySingle"  [placeholder]="'Seleziona una classe'" [data]="classiList" [(ngModel)]="filtro.selectedClasse" (ngModelChange)="onInput($event)">
        </ng-multiselect-dropdown>
      </span>
    </div>
    <div class="col-lg-2" *ngIf="!Entity">
      <label>{{ 'ospite' | translate }}</label>
      <!-- <input class="form-control " (ngModelChange)="onInput($event)" type="text" placeholder="Scrivi un Ospite" [(ngModel)]="filtro.ospite"> -->
      <ng-multiselect-dropdown [settings]="{textField:'fullName', singleSelection:true, singleOutput:true}" (ngModelChange)="onInput($event)"
        [placeholder]="'ospite' | translate" [data]="Persone" [(ngModel)]="filtro.ospiteObject">
      </ng-multiselect-dropdown>
    </div>
    <div class="col-lg-2">
      <label>Inizio</label>
      <input class="form-control"  type="date" [(ngModel)]="filtro.inizio" (ngModelChange)="onInput($event)">
    </div>
    <div class="col-lg-2">
      <label>Fine</label>
      <input class="form-control"  type="date" [(ngModel)]="filtro.fine" (ngModelChange)="onInput($event)">
    </div>
    <div class="col-lg-2" *ngIf="!envirovment['HideStatoRegistroPresenze']">
      <span>
        <label>Stato</label>
        <ng-multiselect-dropdown [settings]="multipleState ? dropSettingSingle : dropSetting"  [placeholder]="'Seleziona uno Stato'" [data]="filtro.tipi" [(ngModel)]="filtro.selectedTipi" (ngModelChange)="onInput($event)">
        </ng-multiselect-dropdown>
      </span>
    </div>

  </div>

  <div *ngIf="Persone && columns">
    <div class="bg-white" style="    overflow-x: scroll;">
      <table class="table">
          <thead>
              <tr>
                  <td></td>
                  <td *ngIf="showClasse"></td>
                  <ng-container *ngFor="let attivita of columns; let i = index">
                    <td *ngIf="!Data(attivita?.data_inizio_prevista).Festivo || !longWeek" style="border-right: 1px solid gray;  text-align: center; min-width: 5rem;"  [colSpan]="CampiColonne?.length ?? 1"
                    [style.borderRight]="(columns[i+1] && Data(columns[i+1]?.data_inizio_prevista).Festivo) ? '' : ''">
                      {{attivita?.data_inizio_prevista | date: 'dd/MM'}} <br>
                      <span [ngClass]="Data(attivita?.data_inizio_prevista).Festivo ? 'text-danger' : ''">{{Data(attivita?.data_inizio_prevista).dayName}}</span>
                    </td>
                  </ng-container>
              </tr>
              <tr *ngIf="!longWeek">
                  <td class="sticky-col sticky-header" style="min-width: 12rem;border-right: 1px solid gray;" [ngStyle]="">{{this.longWeek ? '' : 'Ospiti'}}</td> <!--Ospiti-->
                  <ng-container *ngIf="!CampiColonne "><td *ngFor="let attivita of columns" colspan="1"> </td></ng-container>

              </tr>
          </thead>
          <tbody>
              <tr *ngFor="let cliente of Persone">
                  <td class="sticky-col" style="min-width: 12rem"  [ngStyle]="{ 'border-right': showClasse ? '0px solid' : '1px solid gray' }">{{cliente.fullName ?? cliente.nominativo}}</td>
                  <td *ngIf="showClasse" style="min-width: 12rem; border-right: 1px solid grey;">{{cliente.occupazione}}</td>
                    <ng-container *ngFor="let column of columns; let i = index">
                        <ng-container *ngFor="let attivita of column.Tasks; let j = index">
                            <ng-container  *ngIf="cliente.id == attivita[EntityParam]">

                              <td *ngIf="!Data(column?.data_inizio_prevista).Festivo || !longWeek" (click)="Click(attivita.task, cliente, attivita)"
                              [style.borderRight]= "showBorderRight(i)"
                              > <i [ngbTooltip]="Tooltip(attivita.task) ?? 'N/A'"  [ngClass]="BadgeSelect(attivita.task)"></i> </td>
                            </ng-container>
                        </ng-container>
                    </ng-container>
              </tr>
          </tbody>
      </table>
      <div class="m-t-10" *ngIf="hasSave">
        <button type="submit" type="button" [ngClass]="'btn'"    (click)='Save()'>
          <i [ngClass]="'fas f text-info'" class="font-14 mr-1 "></i>
          <span [ngClass]="'text-info'"> {{'Fine' | translate}} </span>
        </button>
      </div>
  </div>
  </div>

  <div>
    <app-legenda [legenda]="TaskSctructure?.legenda ?? legenda"></app-legenda>
  </div>
</div>

<div class="bg-white p-2" *ngIf="report && !report.anno">
 <span class="text-danger">Report non disponibile!</span>
</div>
